<template>
  <div class="d-flex align-items-center note-title">
    <i class="fas fa-fw fa-home root mr-2 pt-1" v-if="note.id === rootNote.id"></i>
    <input type="text" class="m-0 p-0 w-100" v-model="updatedTitle">
  </div>
</template>
<script>
export default {
  props: ['note'],
  computed: {
    rootNote() {
      return this.$store.getters.rootNote
    }
  },
  data() {
    return {
      updatedTitle: this.note.title
    }
  },
  watch: {
    note() {
      this.updatedTitle = this.note.title
    },
    updatedTitle() {
      if (this.updatedTitle !== this.title) {
        this.$emit('update', this.updatedTitle)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.note-title {
  font-size: 2.35rem;
  font-weight: 400;
  line-height: normal;
}
.note-title input {
  border: 0px solid transparent;
  outline: 0px solid transparent;
  background-color: transparent;
}
.note-title:hover {
  background-color: $gray-200;
  border-radius: $border-radius;
}
.fa-home {
  font-size: 1rem;
  color: $gray-300;
}
</style>
